import { ROAST_CONFIG } from '../config.js';

export default {
    getServices: function(distance, workroom, makeId, licensePlate, latitude, longitude) {
        return axios.get(ROAST_CONFIG.API_URL + '/services', {
            params: {
                distance: distance,
                workroom: workroom,
                make_id: makeId,
                vehicle: licensePlate,
                latitude: latitude,
                longitude: longitude
            }
        });
    },

    getService: function(slug, distance, workroom, makeId, licensePlate, latitude, longitude) {
        return axios.get(ROAST_CONFIG.API_URL + '/services/' + slug, {
            params: {
                distance: distance,
                workroom: workroom,
                make_id: makeId,
                vehicle: licensePlate,
                latitude: latitude,
                longitude: longitude
            }
        });
    },

    getSlotDefinition: function(workroom_id) {
        return axios.get(ROAST_CONFIG.API_URL + '/slots/definition/' + workroom_id, {
            /*params: {
                distance: '2020-08-24',
            }*/
        });
    },

    getSlots: function(workroom_id, workroom) {
        return axios.get(ROAST_CONFIG.API_URL + '/slots/' + workroom_id, {
            params: {
                workroom: workroom
            }
        });
    },

    blockSlot: function(slot_id, blocked_date) {
        return axios.post(ROAST_CONFIG.API_URL + '/slots/block/' + slot_id,
            {
                blocked_date: blocked_date
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    },

    unblockSlot: function(slot_id) {
        return axios.post(ROAST_CONFIG.API_URL + '/slots/unblock/' + slot_id, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
    },

    cancelScenario: function(token) {
        return axios.post(ROAST_CONFIG.API_URL + '/services/cancel-scenario/' + token, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
    },

    orderService: function(
        serviceWorkroomId,
        serviceName,
        slotId,
        slotDate,
        slotTime,
        preferredLanguage,
        clientLocation,
        licensePlate,
        mileage,
        firstName,
        lastName,
        emailAddress,
        phoneNumber,
        phoneNumberPrefix,
        checkedDateType,
        preferredDate1,
        preferredDateTime1,
        preferredDate2,
        preferredDateTime2,
        preferredDate3,
        preferredDateTime3,
        preferredDatePeriod,
        preferredDatePeriodFrom,
        serviceOperations,
        serviceOperationsRepairText,
        serviceOperationsBreakdownText,
        serviceOperationsOtherText,
        extendedServicesOperations,
        extendedServicesOperationsReplacementCarAdditional,
        serviceSupplierLocation,
        pickupNote,
        pickupStreet,
        pickupTown,
        pickupZip,
        pickupGpsLat,
        pickupGpsLng,
        serviceInformation,
        serviceSlotDefinition
    ) {
        return axios.post(ROAST_CONFIG.API_URL + '/services/order', {
                service_workroom_id: serviceWorkroomId,
                service_name: serviceName,
                slot_id: slotId,
                slot_date: slotDate,
                slot_time: slotTime,
                preferred_language: preferredLanguage,
                client_location: clientLocation,
                license_plate: licensePlate,
                mileage	: mileage,
                first_name: firstName,
                last_name: lastName,
                email_address: emailAddress,
                phone_number: phoneNumber,
                phone_number_prefix: phoneNumberPrefix,
                checked_date_type: checkedDateType,
                preferred_date_1: preferredDate1,
                preferred_date_time_1: preferredDateTime1,
                preferred_date_2: preferredDate2,
                preferred_date_time_2: preferredDateTime2,
                preferred_date_3: preferredDate3,
                preferred_date_time_3: preferredDateTime3,
                preferred_date_period: preferredDatePeriod,
                preferred_date_period_from: preferredDatePeriodFrom,
                service_operations: serviceOperations,
                service_operations_repair_text: serviceOperationsRepairText,
                service_operations_breakdown_text: serviceOperationsBreakdownText,
                service_operations_other_text: serviceOperationsOtherText,
                extended_services_operations: extendedServicesOperations,
                extended_services_operations_replacement_car_additional: extendedServicesOperationsReplacementCarAdditional,
                service_supplier_location: serviceSupplierLocation,
                pickup_note: pickupNote,
                pickup_street: pickupStreet,
                pickup_town: pickupTown,
                pickup_zip: pickupZip,
                pickup_gps_lat: pickupGpsLat,
                pickup_gps_lng: pickupGpsLng,
                service_information: serviceInformation,
                service_slot_definition: serviceSlotDefinition
            },
            {
                headers: {
                    'Content-Type': 'application/json'
            }
        });
    },

    orderInspection: function(
        serviceWorkroomId,
        serviceName,
        slotId,
        slotDate,
        preferredLanguage,
        clientLocation,
        licensePlate,
        mileage,
        firstName,
        lastName,
        emailAddress,
        phoneNumber,
        phoneNumberPrefix,
        serviceInformation,
        serviceSlotDefinition
    ) {
        return axios.post(ROAST_CONFIG.API_URL + '/services/order-inspection', {
                service_workroom_id: serviceWorkroomId,
                service_name: serviceName,
                slot_id: slotId,
                slot_date: slotDate,
                preferred_language: preferredLanguage,
                client_location: clientLocation,
                license_plate: licensePlate,
                mileage	: mileage,
                first_name: firstName,
                last_name: lastName,
                email_address: emailAddress,
                phone_number: phoneNumber,
                phone_number_prefix: phoneNumberPrefix,
                service_information: serviceInformation,
                service_slot_definition: serviceSlotDefinition
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    postAuthorize: function(vehicle) {
        return axios.post(ROAST_CONFIG.API_URL + '/authorize',
            {
                vehicle: vehicle
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    },

    postYourPassData: function(yourpassId) {
        return axios.post(ROAST_CONFIG.API_URL + '/authorize/yourpass',
            {
                yourpass_id: yourpassId
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }
}
